import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, pick } from 'lodash';
import { srpLinkBuilder } from 'site-modules/shared/utils/srp-link-constructor';
import { replaceToSeoKeys } from 'site-modules/shared/utils/inventory/params-conversion';
import { PAGE_NUMBER as SEO_PAGE_NUMBER } from 'site-modules/shared/constants/allowed-seo-srp-request-params';
import { PERSIST_URL_PATHNAME_FILTERS } from 'site-modules/shared/utils/inventory/search-filter';
import { PaginationLink } from 'site-modules/shared/components/pagination-link/pagination-link';
import { CommonPagination } from 'site-modules/shared/components/common-pagination/common-pagination';

export const SrpPagination = memo(({ selectedFacets, urlContext, pathName, inventoryCount, ...rest }) => {
  const getPageUrl = useCallback(
    page => {
      // For the first page, page number should not be in parameters list
      const isNumberHidden = Number(page) === 1;

      const requestParams = isEmpty(urlContext) ? selectedFacets : pick(selectedFacets, PERSIST_URL_PATHNAME_FILTERS);
      return srpLinkBuilder(
        replaceToSeoKeys({ ...requestParams, [SEO_PAGE_NUMBER]: isNumberHidden ? null : page }),
        pathName
      );
    },
    [pathName, selectedFacets, urlContext]
  );

  return (
    <CommonPagination
      paginationLinkBuilder={getPageUrl}
      linkComponent={PaginationLink}
      totalCount={inventoryCount}
      dataTrackingParent="edm-entry-srp-pagination"
      showNoPagesCopy
      {...rest}
    />
  );
});

SrpPagination.propTypes = {
  pageNumber: PropTypes.number,
  pagesCount: PropTypes.number,
  maxAllowedPageNumber: PropTypes.number,
  pageResultsCount: PropTypes.number,
  pageSize: PropTypes.number,
  inventoryCount: PropTypes.number,
  selectedFacets: PropTypes.shape({}),
  urlContext: PropTypes.shape({}),
  pathName: PropTypes.string,
  classes: PropTypes.string,
  onPageLinkClick: PropTypes.func,
  isMobile: PropTypes.bool,
  renderNumberLinkComponent: PropTypes.func,
};

SrpPagination.defaultProps = {
  pageNumber: 1,
  pagesCount: 0,
  maxAllowedPageNumber: 0,
  pageSize: 1,
  pageResultsCount: 0,
  inventoryCount: 0,
  onPageLinkClick: null,
  selectedFacets: {},
  urlContext: {},
  pathName: '',
  classes: '',
  isMobile: false,
  renderNumberLinkComponent: undefined,
};
